module.exports = __webpack_public_path__ + "img/constelacion.2322d3d2.png";